// ja strings for messages/studio.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const studio: Dict = {
  // pages/create.tsx
  "studio.title.none": "AIカバーを作成",
  "studio.title.one": "{name}に歌わせる",
  "studio.title.many": "みんなに歌わせる",
  "studio.section.voice": "ボイス",
  "studio.section.whoSings": "誰が歌う？",
  "studio.section.count": "{n} / {max}",
  "studio.section.audio": "音声",
  "studio.pickVoice": "ボイスを選ぶ",
  "studio.pickVoiceNote": "10万以上のボイス、または自分の声から",
  "studio.addVoice": "ボイスを追加",
  "studio.whoSingsWhen": "どこを誰が歌う？",
  "studio.sound": "サウンド",
  "studio.video": "動画",
  "studio.video.off": "Marble Runでボイス同士をレースさせよう",
  "studio.video.on": "Marble Run · 1コイン",
  "studio.video.add": "Marble Runを追加 · 1コイン",
  "studio.coins.unlimited": "Powerならコイン無制限",
  "studio.coins.one": "残り{count}コイン",
  "studio.coins.other": "残り{count}コイン",
  "studio.done": "完了",
  "studio.remove": "削除",
  "studio.cta.pickVoice": "まずボイスを選んでください",
  "studio.cta.addAudio": "音声を追加",
  "studio.cta.create": "カバーを作成",
  "studio.auth.video": "登録して動画を作成",
  "studio.auth.audio": "登録して音声を使う",
  "studio.auth.save": "カバーを保存",
  "studio.upgrade.marbleRun": "CreatorにアップグレードしてMarble Run動画を作成",
  "studio.creatorReady": "Creatorプランです。Marble Runを選んでください。",
  "studio.maxVoices": "選べるボイスは最大{max}個です。",
  "studio.alreadyIn": "{name}はすでにこのカバーに入っています。",

  // VoicePicker
  "studio.voices.search": "ボイスを検索",
  "studio.voices.clear": "検索をクリア",
  "studio.voices.trending": "トレンド",
  "studio.voices.recent": "最近使った",
  "studio.voices.mine": "マイボイス",
  "studio.voices.music": "音楽",
  "studio.voices.cartoon": "カートゥーン",
  "studio.voices.gaming": "ゲーム",
  "studio.voices.anime": "アニメ",
  "studio.voices.publicFigure": "有名人",
  "studio.voices.oftenWith": "{name}とよく一緒に使われる",
  "studio.voices.pairedWith": "{name}とよく組み合わされる",
  "studio.voices.add": "{name}を追加",
  "studio.voices.change": "{name}を変更",
  "studio.voices.removeName": "{name}を削除",
  "studio.voices.upTo": "最大{max}個",
  "studio.voices.makeDuet": "デュエットにする",
  "studio.voices.uses": "{n}回使用",
  "studio.voices.noMatch": "検索に一致するボイスはありません。",
  "studio.voices.noMine": "トレーニングしたボイスはまだありません。",
  "studio.voices.noPairs":
    "今週はこのボイスのデュエットはまだありません。トレンドを見てみましょう。",
  "studio.empty": "まだ何もありません。",
  "studio.change": "変更",

  // WhoSings
  "studio.who.auto": "おまかせ",
  "studio.who.manual": "自分で選ぶ",
  "studio.who.chose.one": "自分で選択 · {n}パート",
  "studio.who.chose.other": "自分で選択 · {n}パート",
  "studio.who.autoExplain": "歌い手が変わるところで、ボイスが交代で歌います。",
  "studio.who.autoCanChoose":
    "自分で決めたい場合は「自分で選ぶ」で、パートごとに歌うボイスを選べます。",
  "studio.who.autoNeedsFile":
    "自分で選ぶには、アップロード、録音、またはライブラリの曲が必要です。",
  "studio.who.loading": "曲を読み込み中…",
  "studio.who.failed":
    "この曲はここで再生できないため、Jammableが自動で割り振ります。",
  "studio.who.pause": "一時停止",
  "studio.who.playSong": "曲を再生",
  "studio.who.partLabel": "{name}、{start}〜{end}",
  "studio.who.moveSwap": "ボイスが交代する位置を動かす",
  "studio.who.part": "パート{n}",
  "studio.who.play": "再生",
  "studio.who.split": "分割",
  "studio.who.takeOver": "このパートは誰が歌いますか？",
  "studio.who.before": "前のパート",
  "studio.who.after": "後のパート",
  "studio.who.sungBy": "歌うボイス",
  "studio.who.hint":
    "パートをタップすると試聴して歌うボイスを選べます。白いハンドルをドラッグすると、ボイスが交代する位置を動かせます。",
  "studio.who.tooShort": "各パートは{secs}秒以上必要です。",

  // SongPicker
  "studio.song.upload": "アップロード",
  "studio.song.library": "ライブラリ",
  "studio.song.tts": "テキスト入力",
  "studio.song.generate": "AIソング",
  "studio.song.mic": "録音",
  "studio.song.sources": "曲の取得方法",
  "studio.song.rights": "使用する権利のある音声のみアップロードしてください。",
  "studio.song.search": "曲を検索",
  "studio.song.searchUploads": "アップロードした曲を検索",
  "studio.song.searchLibrary": "曲ライブラリを検索",
  "studio.song.popular": "人気",
  "studio.song.yourUploads": "アップロード済み",
  "studio.song.noMatch": "検索に一致する曲はありません。",
  "studio.song.noUploads": "まだ何もアップロードしていません。",
  "studio.song.picked": "選択中",
  "studio.source.generate": "AI生成",
  "studio.source.upload": "アップロード",
  "studio.source.library": "ライブラリから",
  "studio.source.mic": "録音",
  "studio.source.tts": "テキスト読み上げ",

  // SongSources: Type words
  "studio.tts.what": "何をしゃべらせますか？",
  "studio.tts.placeholder": "しゃべらせたい言葉を入力...",
  "studio.tts.baseVoice": "ベースの声",
  "studio.tts.accent": "アクセント",
  "studio.tts.delivery": "話し方",
  "studio.tts.use": "この言葉を使う",
  "studio.tts.empty": "テキストを入力してください。",
  "studio.tts.tooLong": "テキストが上限の{max}文字を超えています。",
  "studio.tts.gender.female": "女性",
  "studio.tts.gender.male": "男性",
  "studio.tts.accent.US": "アメリカ英語",
  "studio.tts.accent.GB": "イギリス英語",
  "studio.tts.accent.FR": "フランス語",
  "studio.tts.accent.DE": "ドイツ語",
  "studio.tts.accent.ES": "スペイン語",
  "studio.tts.accent.IT": "イタリア語",
  "studio.tts.accent.KR": "韓国語",
  "studio.tts.accent.AU": "オーストラリア英語",
  "studio.tts.accent.JP": "日本語",
  "studio.tts.expr.default": "標準",
  "studio.tts.expr.whispered": "ささやき",
  "studio.tts.expr.happy": "うれしい",
  "studio.tts.expr.sad": "悲しい",
  "studio.tts.expr.angry": "怒り",
  "studio.tts.expr.shouting": "叫び",
  "studio.tts.expr.terrified": "おびえ",

  // SongSources: AI song
  "studio.ai.style": "スタイルを選ぶか、言葉で説明",
  "studio.ai.styleLabel": "曲のスタイル",
  "studio.ai.stylePlaceholder":
    "例：アップテンポな夏のポップ、アコースティックギター、キャッチーなサビ",
  "studio.ai.lyrics": "歌詞",
  // [Verse], [Chorus], [Bridge] are tags the generator reads: keep them.
  "studio.ai.lyricsPlaceholder":
    "空欄ならAIが歌詞を書きます。自分で書く場合：\n\n[Verse 1]\nここに歌詞を入力...\n\n[Chorus]\n[Verse]、[Chorus]、[Bridge]のタグで曲の構成を指定できます",
  "studio.ai.ownLyrics": "+ 歌詞を自分で書く（書かない場合はAIが作詞）",
  "studio.ai.use": "この曲を使う",
  "studio.ai.noStyle": "曲のスタイルを入力してください。",
  "studio.ai.styleTooLong": "スタイルの説明は{max}文字未満にしてください。",
  "studio.ai.lyricsTooLong": "歌詞は{max}文字未満にしてください。",
  "studio.ai.genre.pop": "ポップ",
  "studio.ai.genre.trap": "トラップ",
  "studio.ai.genre.rnb": "R&B",
  "studio.ai.genre.indie": "インディー",
  "studio.ai.genre.kpop": "K-POP",
  "studio.ai.genre.edm": "EDM",
  "studio.ai.genre.lofi": "ローファイ",
  "studio.ai.genre.country": "カントリー",
  "studio.seo.title": "AIカバーを作成 | Jammable",
  "studio.seo.description":
    "ボイスを選び、使用する権利のある音声を追加して、JammableでAIカバーを作成しましょう。",
};

export default studio;
